export default "__VITE_PUBLIC_ASSET__ec3f4e93__"